export const GLOSSARY_TERMS = {
  COATING_AREA: { handle: 'coating_area', name: 'coating area' },
  COMBI_WIDTH: { handle: 'combi_width', name: 'width' },
  COMBI_DEPTH: { handle: 'combi_depth', name: 'depth' },
  PIPE_DIAMETER: { handle: 'pipe_diameter', name: 'pipe diameter' },
  FLANGE_THICKNESS: { handle: 'flange_thickness', name: 'flange thickness' },
  SAFETY_FACTOR: { handle: 'safety_factor', name: 'safety factor' },
  SECTION_AREA: { handle: 'section_area', name: 'section area' },
  SECTION_DEPTH: { handle: 'section_depth', name: 'section depth' },
  SECTION_WEIGHT: { handle: 'section_weight', name: 'section weight' },
  WEB_THICKNESS: { handle: 'web_thickness', name: 'web thickness' },
  PROJECTED_SECTION_MODULUS: {
    handle: 'projected_section_modulus',
    name: 'projected section modulus',
  },
  SHEET_PILE_CONNECTOR: {
    handle: 'sheet_pile_connector',
    name: 'sheet pile connector',
  },
  QUANTITY_CONVERTER_TOOL: {
    handle: 'quantity_converter_tool',
    name: 'quantity converter tool',
  },
  FLANGE_WIDTH: { handle: 'flange_width', name: 'flange width' },
  CONNECTOR: { handle: 'connector', name: 'connector' },
  INTERMEDIATE_PILE_HEIGHT: {
    handle: 'intermediate_pile_height',
    name: 'sheet piling height',
  },
  SEALANT: { handle: 'sealant', name: 'sealant' },
  WATERPROOFING: { handle: 'waterproofing', name: 'waterproofing' },
  CANTILEVER_WALL: { handle: 'cantilever_wall', name: 'cantilever wall' },
  DOUBLE_U_PILE: { handle: 'double_u_pile', name: 'double U-pile' },
  CONTIGUOUS_WALL: { handle: 'contiguous_wall', name: 'contiguous wall' },
  ANCHORS: { handle: 'anchors', name: 'anchors' },
  AVAILABILITY: { handle: 'availability', name: 'availability' },
  BEARING_PILES: { handle: 'bearing_piles', name: 'bearing piles' },
  INTERLOCK_STRENGTH: {
    handle: 'interlock_strength',
    name: 'Interlock strength',
  },
  DRIVEABILITY: { handle: 'driveability', name: 'driveability' },
  HIGH_MODULUS_WALL: { handle: 'high_modulus_wall', name: 'high modulus wall' },
  JAGGED_WALL: { handle: 'jagged_wall', name: 'jagged wall' },
  PILE_COUPLER: { handle: 'pile_coupler', name: 'pile coupler' },
  PROPPED_WALL: { handle: 'propped_wall', name: 'propped wall' },
  KING_PILE_WALL: { handle: 'king_pile_wall', name: 'king pile wall' },
  TRIPLE_U_PILING: { handle: 'triple_u_piling', name: 'triple u piling' },
  WALING: { handle: 'waling', name: 'waling' },
  ELASTIC_SECTION_MODULUS: {
    handle: 'elastic_section_modulus',
    name: 'elastic section modulus',
  },
  Z_SHEET_PILE: { handle: 'z_sheet_pile', name: 'z-sheet pile' },
  COMBINED_SHEET_PILE_H_AND_Z: {
    handle: 'combined_sheet_pile_h_and_z',
    name: 'combined sheet piles: H + Z',
  },
  DRIVING_RATIO: { handle: 'driving_ratio', name: 'driving ratio' },
  WEIGHT_RATIO: { handle: 'weight_ratio', name: 'weight ratio' },
  PANEL_WIDTH: { handle: 'panel_width', name: 'panel width' },
  DESIGN_STRENGTH: { handle: 'design_strength', name: 'design strength' },
  STRENGTH: { handle: 'strength', name: 'strength' },
  PRIMARY_ELEMENTS: { handle: 'primary_elements', name: 'primary elements' },
  SECONDARY_ELEMENTS: {
    handle: 'secondary_elements',
    name: 'secondary elements',
  },
  CORROSION_TOOL_EFFECTS: {
    handle: 'corrosion_tool_effects',
    name: 'corrosion tool effects',
  },
  BEARING_PILE_WIDTH: {
    handle: 'bearing_pile_width',
    name: 'bearing pile width',
  },
  BEARING_PILE_WEB_THICKNESS: {
    handle: 'bearing_pile_web_thickness',
    name: 'bearing pile web thickness',
  },
  BEARING_PILE_FLANGE_THICKNESS: {
    handle: 'bearing_pile_flange_thickness',
    name: 'bearing pile flange thickness',
  },
  CONTIGUOUS_U_SHEET_PILE: {
    handle: 'contiguous_u_sheet_pile',
    name: 'contiguous u-sheet pile',
  },
  SECTION_WIDTH: { handle: 'section_width', name: 'section width' },
  TARGET_WALL_LENGTH: {
    handle: 'target_wall_length',
    name: 'target wall length',
  },
  WEIGHT_PER_AREA: { handle: 'weight_per_area', name: 'weight per area' },
  COMBI_WEIGHT: { handle: 'combi_weight', name: 'weight' },
  PIPE_THICKNESS: { handle: 'pipe_thickness', name: 'pipe thickness' },
  ESTIMATED_PRICE: { handle: 'estimated_price', name: 'estimated price' },
  ACTUAL_WALL_LENGTH: {
    handle: 'actual_wall_length',
    name: 'actual wall length',
  },
  PANEL_QUANTITY: { handle: 'panel_quantity', name: 'panel quantity' },
  BUY_AMERICA: { handle: 'buy_america', name: 'Buy America' },
  DESIGN_LIFE: { handle: 'design_life', name: 'design life' },
  DOCUMENTS: { handle: 'documents', name: 'documents' },
  FLEXIBILITY: { handle: 'flexibility', name: 'flexibility' },
  BEARING_PILE_DEPTH: {
    handle: 'bearing_pile_depth',
    name: 'bearing pile depth',
  },
  ALLOWABLE_BENDING_STRESS: {
    handle: 'allowable_bending_stress',
    name: 'allowable bending stress',
  },
  FILLET_RADIUS: { handle: 'fillet_radius', name: 'fillet radius' },
  INTERLOCK_SEALANT: { handle: 'interlock_sealant', name: 'interlock sealant' },
  WALL_LENGTH: { handle: 'wall_length', name: 'wall length' },
  WALL_HEIGHT: { handle: 'wall_height', name: 'wall height' },
  STEEL_PILING_COMBINED: {
    handle: 'steel_piling_combined',
    name: 'steel piling combined walls',
  },
  CONTIGUOUS_COLD_FORMED_Z_SHEET_PILE: {
    handle: 'contiguous_cold_formed_z_sheet_pile',
    name: 'contiguous cold formed z-sheet pile',
  },
  TIEBACKS: { handle: 'tiebacks', name: 'tiebacks' },
  ENVIRONMENT: { handle: 'environment', name: 'environment' },
  MILL_DIRECT_SYSTEM: {
    handle: 'mill_direct_system',
    name: 'mill direct system',
  },
  BRACING: { handle: 'bracing', name: 'bracing' },
  CELLULAR_COFFERDAM: {
    handle: 'cellular_cofferdam',
    name: 'cellular cofferdam',
  },
  PROJECTED_SPECIFICATIONS: {
    handle: 'projected_specifications',
    name: 'projected specifications',
  },
  SOLDIER_WALL: { handle: 'soldier_wall', name: 'soldier wall' },
  PLASTIC_SECTION_MODULUS: {
    handle: 'plastic_section_modulus',
    name: 'plastic section modulus',
  },
  U_SHEET_PILE: { handle: 'u_sheet_pile', name: 'u-sheet pile' },
  SETTING_RATIO: { handle: 'setting_ratio', name: 'setting ratio' },
  CONTIGUOUS_Z_SHEET_PILE: {
    handle: 'contiguous_z_sheet_pile',
    name: 'contiguous z-sheet pile',
  },
  SOLUTION_COMPARISON: { handle: 'solution_comparison', name: 'wall tool' },
  WADIT: { handle: 'wadit', name: 'wadit' },
  SPECIFICATIONS: { handle: 'specifications', name: 'specifications' },
  INTERLOCK: { handle: 'interlock', name: 'interlock' },
  ACTUAL_MASS: { handle: 'actual_mass', name: 'actual mass' },
  COMBINED_SHEET_PILE_O_AND_Z: {
    handle: 'combined_sheet_pile_o_and_z',
    name: 'combined sheet piles: O + Z',
  },
  SECTION_MODULUS: { handle: 'section_modulus', name: 'section modulus' },
  DESIGN_MOMENT: { handle: 'design_moment', name: 'design moment' },
  MOMENT_OF_INERTIA: { handle: 'moment_of_inertia', name: 'moment of inertia' },
  CONTIGUOUS_O_SHEET_PILE: {
    handle: 'contiguous_o_sheet_pile',
    name: 'contiguous o-pile',
  },
  KING_PILE_HEIGHT: { handle: 'king_pile_height', name: 'king pile height' },
  O_SHEET_PILE: { handle: 'o_sheet_pile', name: 'o-pile' },
  CALCULATED_MASS: { handle: 'calculated_mass', name: 'calculated mass' },
  INTERMEDIATE_PILE_RATIO: {
    handle: 'intermediate_pile_ratio',
    name: 'Intermediate connector/pile Height or Ratio',
  },
  CORROSION_RESISTANCE: {
    handle: 'corrosion_resistance',
    name: 'corrosion resistance',
  },
  BENDING_MOMENT_CAPACITY: {
    handle: 'bending_moment_capacity',
    name: 'Bending moment capacity',
  },
  STEEL_GRADE: { handle: 'steel_grade', name: 'steel grade' },
  COMBI_WALLS: { handle: 'combi_walls', name: 'combined sheet piling walls' },
  PIPE_SHEET_PILING: { handle: 'pipe_sheet_piling', name: 'pipe sheet piling' },
} as const

export type GlossaryTermHandle = keyof typeof GLOSSARY_TERMS
export type GlossaryTermConstant = (typeof GLOSSARY_TERMS)[GlossaryTermHandle]
